import { ApiErrorCode } from './api-error-code';

export interface ApiErrorData {
  [ApiErrorCode.ValidationFailed]: {
    invalid_params: { name: string; reason: string }[];
  };
  [ApiErrorCode.DiscountCannotBeAssigned]: { reasons: string[] };
  [ApiErrorCode.DiscountAssignmentNotSupported]: { type: string };
  [ApiErrorCode.DiscountAssignmentExists]: { type: string | null };
  [ApiErrorCode.DiscountCannotBeUpdated]: { reasons: string[] };
  [ApiErrorCode.MultipleConnectionsFound]: {
    electricity: unknown;
    gas: unknown;
  };
  [ApiErrorCode.UnknownAddress]: { text: string };
  [ApiErrorCode.UserGroupCannotBeDeleted]: {
    has_users: boolean;
    has_discounts: boolean;
    has_referral_codes: boolean;
  };
}

export type ApiErrorDataOf<C extends number> = C extends keyof ApiErrorData
  ? ApiErrorData[C]
  : unknown;

export class ApiError<C extends number = number> extends Error {
  override readonly name = 'ApiError';

  constructor(
    readonly code: C,
    readonly apiMessage: string,
    readonly data: ApiErrorDataOf<C>,
    readonly status: number | undefined,
    override readonly cause: unknown,
  ) {
    super(`API error ${code}: ${apiMessage}`);
  }
}
